export default {
  computed: {
    userinfo: (vm) => vm.$store.state.user.userinfo,
    roadshow: (vm) => vm.$store.state.app.roadshow,
    speakTypes: (vm) => vm.$store.state.app.speakTypes,
    guests: (vm) => vm.$store.state.app.guests,
  },
  methods: {
    affixTarget() {
      return document.querySelector('.page-wrapper')
    },
  },
}
